import { classNames } from "@pomle/classnames";
import { Typography } from "render/ui/presentation/Typography";
import ConsentToggle from "render/views/ProfileView/components/ConsentDocument/components/ConsentToggle";
import {
  ContentProps,
  sharedStyles,
} from "render/views/ProfileView/components/ConsentDocument/components/shared";
import styles from "./styles.module.sass";
import { Trans } from "./trans";

type PatientJournalContentProps = {
  developmentAndTestingLink: string;
} & ContentProps;

export function PatientJournalContent({
  allowEdit,
  checked,
  busy,
  onClick,
  study,
  developmentAndTestingLink,
}: PatientJournalContentProps) {
  return (
    <div className={classNames(sharedStyles.content, styles.consentContainer)}>
      <div className={sharedStyles.title}>
        <Typography variant="title-medium">
          <Trans.Title />
        </Typography>
        <Typography variant="paragraph">
          <Trans.Summary />
        </Typography>
        <Typography variant="paragraph">
          <Trans.Validity />
        </Typography>
      </div>
      <ConsentToggle
        allowEdit={allowEdit}
        checked={checked}
        busy={busy}
        onClick={onClick}
        study={study}
      />
      <div className={styles.divider} />
      <div className={styles.text}>
        <div className={styles.sectionTitle}>
          <Typography variant="title-medium">
            <Trans.HowItWorks />
          </Typography>
        </div>
        <Typography variant="paragraph-large">
          <Trans.Background />
        </Typography>
        <Typography variant="paragraph">
          <Trans.BackgroundParagraph />
        </Typography>
      </div>
      <div className={styles.text}>
        <Typography variant="paragraph-large">
          <Trans.How />
        </Typography>
        <Typography variant="paragraph">
          <Trans.HowParagraph href={developmentAndTestingLink} />
        </Typography>
      </div>
      <div className={styles.text}>
        <Typography variant="paragraph-large">
          <Trans.Process />
        </Typography>
        <Typography variant="paragraph">
          <Trans.ProcessParagraph />
        </Typography>
      </div>
      <div className={styles.text}>
        <Typography variant="paragraph-large">
          <Trans.Withdraw />
        </Typography>
        <Typography variant="paragraph">
          <Trans.WithdrawParagraph />
        </Typography>
      </div>
      <div className={styles.text}>
        <Typography variant="paragraph-large">
          <Trans.Specific />
        </Typography>
        <Typography variant="paragraph">
          <Trans.SpecificParagraph href="https://legal.dev.cur8.co/pdfs/privacy-policy/2023-10-18-Neko-Health-Privacy-Notice.en.pdf" />
        </Typography>
      </div>
    </div>
  );
}
